var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024",
    className: "icon icon-mon-lock",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M512 840c-22.016 0-40-17.984-40-40v-128c0-22.016 17.984-40 40-40s40 17.984 40 40v128c0 22.016-17.984 40-40 40zM959.999 544.001v383.999c0 52.992-43.008 96-96 96h-703.999c-52.992 0-96-43.008-96-96v-383.999c0-52.992 43.008-96 96-96h32v-128c0-176.768 144-320.575 321.023-319.999 176.768 0.576 318.975 146.176 318.975 323.007v124.992h32c52.992 0 96 43.008 96 96zM256 448.001h511.999v-128c0-141.184-114.816-256-256-256s-256 114.816-256 256v128zM895.999 928v-383.999c0-17.6-14.4-32-32-32h-703.999c-17.6 0-32 14.4-32 32v383.999c0 17.6 14.4 32 32 32h703.999c17.6 0 32-14.4 32-32z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.ff75000f.svg";
export { ForwardRef as ReactComponent };